import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Refresh = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0182 2.37196L12.022 2.37195C14.6741 2.37196 17.2177 3.42552 19.093 5.30089C20.9684 7.17625 22.022 9.71979 22.022 12.372C22.022 12.9242 21.5743 13.372 21.022 13.372C20.4697 13.372 20.022 12.9242 20.022 12.372C20.022 10.2502 19.1791 8.21539 17.6788 6.7151C16.179 5.21525 14.1449 4.37245 12.0238 4.37196C9.76928 4.38092 7.60527 5.2598 5.98294 6.8252L5.43619 7.37196H8.02197C8.57426 7.37196 9.02197 7.81967 9.02197 8.37196C9.02197 8.92424 8.57426 9.37196 8.02197 9.37196H3.02197C2.46969 9.37196 2.02197 8.92424 2.02197 8.37196V3.37196C2.02197 2.81967 2.46969 2.37196 3.02197 2.37196C3.57426 2.37196 4.02197 2.81967 4.02197 3.37196V5.95774L4.57487 5.40485L4.58693 5.39299C6.58143 3.46485 9.24411 2.3824 12.0182 2.37196ZM4.9509 19.443C3.07554 17.5677 2.02197 15.0241 2.02197 12.372C2.02197 11.8197 2.46969 11.372 3.02197 11.372C3.57426 11.372 4.02197 11.8197 4.02197 12.372C4.02197 14.4937 4.86483 16.5285 6.36512 18.0288C7.865 19.5287 9.89912 20.3715 12.0202 20.372C14.2748 20.363 16.4387 19.4841 18.061 17.9187L18.6078 17.372H16.022C15.4697 17.372 15.022 16.9242 15.022 16.372C15.022 15.8197 15.4697 15.372 16.022 15.372H21.022C21.5743 15.372 22.022 15.8197 22.022 16.372V21.372C22.022 21.9242 21.5743 22.372 21.022 22.372C20.4697 22.372 20.022 21.9242 20.022 21.372V18.7862L19.4691 19.3391L19.457 19.3509C17.4625 21.2791 14.7998 22.3615 12.0257 22.3719L12.022 22.372C9.36981 22.372 6.82627 21.3184 4.9509 19.443Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};
